import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { Star, ChevronLeft, ChevronRight } from "lucide-react";
import { TESTIMONIALS } from "../../content/site";
import { SectionHeading } from "./Motion";
import { Floral } from "./Floral";

export const Testimonials = () => {
  const [i, setI] = useState(0);
  const [paused, setPaused] = useState(false);
  const n = TESTIMONIALS.length;
  useEffect(() => {
    if (paused) return undefined;
    const t = setTimeout(() => setI((x) => (x + 1) % n), 6500);
    return () => clearTimeout(t);
  }, [i, paused, n]);

  return (
    <section id="reviews" className="relative overflow-hidden bg-peach-soft section-pad" data-testid="testimonials-section">
      <Floral pos="bl" />
      <Floral pos="tr" className="w-36 sm:w-52 lg:w-64" />
      <div className="relative z-10 mx-auto max-w-4xl text-center">
        <SectionHeading eyebrow="Kind words" title="Love notes from" script="our couples" align="center" testid="testimonials-heading" />
        <div className="relative mt-14 grid" onMouseEnter={() => setPaused(true)} onMouseLeave={() => setPaused(false)} data-testid="testimonial-slider">
          <span className="pointer-events-none absolute -top-16 left-1/2 -translate-x-1/2 font-serif text-[12rem] leading-none text-peach">“</span>
          {TESTIMONIALS.map((t, k) => (
            <motion.figure
              key={t.name}
              className="relative [grid-area:1/1]"
              initial={false}
              animate={{ opacity: k === i ? 1 : 0, y: k === i ? 0 : 16, filter: k === i ? "blur(0px)" : "blur(4px)" }}
              transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
              aria-hidden={k !== i}
              style={{ pointerEvents: k === i ? "auto" : "none" }}
              data-testid={`testimonial-${k}`}
            >
              <div className="flex justify-center gap-1 text-gold">
                {[0, 1, 2, 3, 4].map((s) => <Star key={s} className="h-4 w-4 fill-gold" />)}
              </div>
              <blockquote className="mt-6 font-serif text-2xl italic leading-snug text-ink sm:text-3xl lg:text-4xl">{t.text}</blockquote>
              <figcaption className="mt-8">
                <p className="font-script text-4xl text-gold">{t.name}</p>
                <p className="mt-1 text-xs uppercase tracking-[0.25em] text-ink-soft">{t.event}</p>
              </figcaption>
            </motion.figure>
          ))}
        </div>
        <div className="mt-10 flex items-center justify-center gap-5">
          <button onClick={() => setI((i - 1 + n) % n)} className="grid h-12 w-12 place-items-center rounded-full border border-gold/40 bg-white/70 text-ink transition-colors hover:bg-gold hover:text-cream" aria-label="Previous review" data-testid="testimonial-prev">
            <ChevronLeft className="h-5 w-5" />
          </button>
          <div className="flex gap-2">
            {TESTIMONIALS.map((t, k) => (
              <button key={t.name} onClick={() => setI(k)} className={`h-2 rounded-full transition-[width,background-color] duration-500 ${k === i ? "w-8 bg-gold" : "w-2 bg-gold/30"}`} aria-label={`Review ${k + 1}`} data-testid={`testimonial-dot-${k}`} />
            ))}
          </div>
          <button onClick={() => setI((i + 1) % n)} className="grid h-12 w-12 place-items-center rounded-full border border-gold/40 bg-white/70 text-ink transition-colors hover:bg-gold hover:text-cream" aria-label="Next review" data-testid="testimonial-next">
            <ChevronRight className="h-5 w-5" />
          </button>
        </div>
      </div>
    </section>
  );
};
